<div class="vi-footer">
  <ng-content></ng-content>
</div>
